<template>
  <div>
    <v-snackbar 
      v-model="snackbar"
      right
      :color="type"
    >
      <v-icon
        v-if="type === 'error'"  
        class="mr-2"
      >
        mdi-alert-circle
      </v-icon>
      <v-icon
        v-else 
        class="mr-2"
      >
        mdi-check-circle
      </v-icon>

      <slot
        v-if="type === 'error'" 
        name="error"
      >
        {{ computedMessage }}
      </slot>
      <slot
        v-else
        name="success"
      >
        {{ message }}
      </slot>
    </v-snackbar>
  </div>
</template>

<script>
import { messages } from '../common/messages'

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'success',
    },
    message: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      snackbar: false,
    };
  },
  watch: {
    value(newValue) {
      this.snackbar = newValue
    },
    text(newText) {
      this.$emit('input', newText)
    },
  },
  computed: {
    computedMessage() {
      return this.message && messages[this.message] ? 
        messages[this.message] : this.message
    },
  },
};
</script>

